import React from "react";
import cs from "classnames";
import styles from "./styles.module.scss";
import { OrdersIcon } from "./icons";
import { OrderTimelineRow, OrderStatusBadge } from "../OrderTimeline";
import { RecentOrdersProps } from "./types";

// Status pill re-exported for backward compatibility — the implementation
// lives in the shared OrderTimeline module now.
export { OrderStatusBadge };

/**
 * Recent-orders card (Figma 568:75376). Pure presentational: a list of
 * status-toned order rows (id + type pill, progress, status control) or an
 * empty-state message. Rows come from the shared OrderTimeline atoms.
 */
export const RecentOrders: React.FC<RecentOrdersProps> = ({
  orders,
  onSeeAll,
  seeAllSlot,
  renderStatus,
  emptyText = "No orders. They will be displayed here",
  className,
}) => {
  const seeAll =
    seeAllSlot ??
    (onSeeAll ? (
      <button type="button" className={styles.seeAll} onClick={onSeeAll}>
        See all
      </button>
    ) : null);

  return (
    <div className={cs(styles.card, className)}>
      <div className={styles.head}>
        <div className={styles.title}>
          <span className={styles.iconBox}>
            <OrdersIcon className={styles.icon20} />
          </span>
          <h3 className={styles.heading}>Recent orders</h3>
        </div>
        {seeAll}
      </div>

      {orders.length ? (
        <div className={styles.list}>
          {orders.map((o) => (
            <OrderTimelineRow
              key={`${o.id}-${o.status}`}
              id={o.id}
              label={o.label}
              status={o.status}
              percent={o.completion}
              statusSlot={renderStatus?.(o)}
            />
          ))}
        </div>
      ) : (
        <div className={styles.empty}>
          <p className={styles.emptyText}>{emptyText}</p>
        </div>
      )}
    </div>
  );
};

export default RecentOrders;
